import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import "../common/elements/Header.scss";
import translate from "src/i18n/translate";
import Header from "src/features/common/elements/Header";
import OrgProfileContent from "src/features/common/elements/OrgProfileContent";
import ScrollableHeader from "../common/elements/ScrollableHeader";
import { useContext, useEffect } from "react";
import { onScrollChangeBreadCrumb } from "../../static/js/commons";
import { AppContext } from "src/contexts/AppContext";
import PreviewModal from "../lightcast/PreviewModal";
import UnauthorizedComponent from "src/features/insights/UnauthorizedComponent";
import { usePageTitle } from 'src/hooks/usePageTitle';
import { useIntl } from 'react-intl';
export default function OrgProfileComponent(_a) {
    var setSelectedTabView = _a.setSelectedTabView, auth = _a.auth;
    var institution = useContext(AppContext).institution;
    var intl = useIntl();
    var pageTitle = (institution === null || institution === void 0 ? void 0 : institution.name)
        ? "".concat(institution.name, " - ").concat(intl.formatMessage({ id: 'app.pageTitle.institutionProfile' }))
        : intl.formatMessage({ id: 'app.pageTitle.institutionProfile' });
    usePageTitle(pageTitle);
    useEffect(function () {
        setTimeout(function () {
            onScrollChangeBreadCrumb(institution === null || institution === void 0 ? void 0 : institution.navigatedFrom);
        }, 1000);
    }, []);
    var displayName = institution && institution.name;
    return (_jsx(_Fragment, { children: auth ? (_jsxs(_Fragment, { children: [_jsx(Header, { displayName: displayName }), _jsx(ScrollableHeader, { displayName: displayName }), _jsx("div", { className: "insights-hub-body flex-row", children: _jsx("div", { id: "main-org-profile-container", className: "main-org-profile", children: _jsxs("div", { children: [_jsxs("div", { className: "page-banner -insights-header insights-header-home", children: [_jsx("h2", { className: "titles", children: "Insights" }), _jsx("div", { className: "description", children: translate("app.header.description") })] }), _jsx("div", { className: "body -height", id: "tab-components", children: _jsx(OrgProfileContent, { setSelectedTabView: setSelectedTabView }) })] }) }) }), _jsx(PreviewModal, {})] })) : (_jsx(UnauthorizedComponent, {})) }));
}
